<!-- 组件说明 -->
<template>
  <div class="container">
    <div class="title">
      <span class="title_name">{{title}}</span>
      <span class="sub_title">{{desc}}</span>
    </div>
    <div class="slot_wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
//import x from ''
export default {
  props: ['title', 'desc'],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {
    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.container {
  box-sizing: border-box;
  border: 1px #ddd solid;
  .title {
    box-sizing: border-box;
    height: 1.6rem;
    width: 100%;
    background: #fafafa;
    border-bottom: 1px #ddd solid;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title_name {
      margin-left: 0.8rem;
      font-size: 0.6rem;
    }
    .sub_title {
      margin-right: 0.8rem;
    }
  }
  .slot_wrapper {
    padding: 0.8rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/container.vue